<form name="form" (ngSubmit)="f.form.valid && onSubmit()" #f="ngForm"  novalidate>
    <div class="form-row">
        <div class="form-group col">
            <label>Title</label>
            <select name="title" class="form-control" [(ngModel)]="model.title" #title="ngModel" [ngClass]="{ 'is-invalid': f.submitted && title.invalid }" required>
                <option value=""></option>
                <option value="Mr">Mr</option>
                <option value="Mrs">Mrs</option>
                <option value="Miss">Miss</option>
                <option value="Ms">Ms</option>
            </select>
            <div *ngIf="f.submitted && title.invalid" class="alert alert-danger">
                <div *ngIf="title.errors?.['required']">Title is required</div>
            </div>
        </div>
        <div class="form-group col-5">
            <label>First Name</label>
            <input type="text" name="firstName" class="form-control" [(ngModel)]="model.firstName" #firstName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && firstName.invalid }" required>
            <div *ngIf="f.submitted && firstName.invalid" class="alert alert-danger">
                <div *ngIf="firstName.errors?.['required']">First Name is required</div>
            </div>
        </div>
        <div class="form-group col-5">
            <label>Last Name</label>
            <input type="text" name="lastName" class="form-control" [(ngModel)]="model.lastName" #lastName="ngModel" [ngClass]="{ 'is-invalid': f.submitted && lastName.invalid }" required>
            <div *ngIf="f.submitted && lastName.invalid" class="alert alert-danger">
                <div *ngIf="lastName.errors?.['required']">Last Name is required</div>
            </div>
        </div>
    </div>
    <div class="form-group">
        <label>Email</label>
        <input type="text" name="email" class="form-control" [(ngModel)]="model.email" #email="ngModel" [ngClass]="{ 'is-invalid': f.submitted && email.invalid }" required email>
        <div *ngIf="f.submitted && email.invalid" class="alert alert-danger">
            <div *ngIf="email.errors?.['required']">Email is required</div>
            <div *ngIf="email.errors?.['email']">Email must be a valid email address</div>
        </div>
    </div>
    <div class="form-row">
        <div class="form-group col">
            <label>Password</label>
            <input type="password" name="password" class="form-control" [(ngModel)]="model.password" #password="ngModel" [ngClass]="{ 'is-invalid': f.submitted && password.invalid }" required minlength="6">
            <div *ngIf="f.submitted && password.invalid" class="alert alert-danger">
                <div *ngIf="password.errors?.['required']">Password is required</div>
                <div *ngIf="password.errors?.['minlength']">Password must be at least 6 characters</div>
            </div>
        </div>
        <div class="form-group col">
            <label>Confirm Password</label>
            <input type="password" name="confirmPassword" class="form-control" [(ngModel)]="model.confirmPassword" #confirmPassword="ngModel" [ngClass]="{ 'is-invalid': f.submitted && confirmPassword.invalid }" required>
            <div *ngIf="f.submitted && confirmPassword.invalid" class="alert alert-danger">
                <div *ngIf="confirmPassword.errors?.['required']">Confirm Password is required</div>
                <div *ngIf="confirmPassword.errors?.['mustMatch']">Passwords must match</div>
            </div>
        </div>
    </div>
    <div class="form-group form-check">
        <input type="checkbox" name="acceptTerms" id="acceptTerms" class="form-check-input" [(ngModel)]="model.acceptTerms" #acceptTerms="ngModel" [ngClass]="{ 'is-invalid': f.submitted && acceptTerms.invalid }" required>
        <label for="acceptTerms" class="form-check-label">Accept Terms & Conditions</label>
        <div *ngIf="f.submitted && acceptTerms.invalid" class="alert alert-danger">Accept Ts & Cs is required</div>
    </div>
    <div class="text-center">
        <button class="btn btn-primary mr-1">Register</button>
        <button class="btn btn-secondary" type="reset">Cancel</button>
    </div>
</form>
